import React from 'react'
import { capitalize } from 'lodash'
import { DataTypeProvider } from '@devexpress/dx-react-grid'
import { deepOrange500, greenA700 } from 'material-ui-legacy/styles/colors'

import { formatDate, monetize, percentize, niceCount } from '../../lib/formats'

// Formatter functions/components to be used (not only) with <DataGrid>

/*
* Date formatting
*/
const DateFormatter = ({ value }) => {
  const dateOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  }

  return <span>{formatDate(value, dateOptions)}</span>
}

const DateTypeProvider = props => (
  <DataTypeProvider formatterComponent={DateFormatter} {...props} />
)

/*
* Currency formatting
*/
const CurrencyFormatter = ({ value }) => <span>{monetize(value)}</span>

const CurrencyTypeProvider = props => (
  <DataTypeProvider formatterComponent={CurrencyFormatter} {...props} />
)

const ColorCurrencyFormatter = ({ value }) => {
  const color = { color: value > 0 ? greenA700 : deepOrange500 }
  return <span style={color}>{monetize(value)}</span>
}

const ColorCurrencyTypeProvider = props => (
  <DataTypeProvider formatterComponent={ColorCurrencyFormatter} {...props} />
)

/*
* Percentage formatting
*/
const PercentageFormatter = ({ value }) => <span>{percentize(value, 2)}</span>

const PercentageTypeProvider = props => (
  <DataTypeProvider formatterComponent={PercentageFormatter} {...props} />
)

const MarginFormatter = ({ value }) => {
  const color = { color: value > 0 ? greenA700 : deepOrange500 }
  return <span style={color}>{percentize(value, 2)}</span>
}

const MarginTypeProvider = props => (
  <DataTypeProvider formatterComponent={MarginFormatter} {...props} />
)

/*
* Count formatters
*/
const ProjectCountFormatter = ({ value }) => (
  <span>{niceCount(value, 'project', 'projects')}</span>
)

const ProjectCountTypeProvider = props => (
  <DataTypeProvider formatterComponent={ProjectCountFormatter} {...props} />
)

const CategoryCountFormatter = ({ value }) => (
  <span>{niceCount(value, 'category', 'categories')}</span>
)

const CategoryCountTypeProvider = props => (
  <DataTypeProvider formatterComponent={CategoryCountFormatter} {...props} />
)

const ServiceCountFormatter = ({ value }) => (
  <span>{niceCount(value, 'service', 'services')}</span>
)

const ServiceCountTypeProvider = props => (
  <DataTypeProvider formatterComponent={ServiceCountFormatter} {...props} />
)

/*
* Text formatters
*/
const WrappedTextFormatter = ({ value }) => (
  <span style={{ whiteSpace: 'normal' }}>{value}</span>
)

const WrappedTextTypeProvider = props => (
  <DataTypeProvider formatterComponent={WrappedTextFormatter} {...props} />
)

const CapitalizedTextFormatter = ({ value }) => <span>{capitalize(value)}</span>

const CapitalizedTextTypeProvider = props => (
  <DataTypeProvider formatterComponent={CapitalizedTextFormatter} {...props} />
)

export {
  DateFormatter,
  CurrencyFormatter,
  ColorCurrencyFormatter,
  PercentageFormatter,
  MarginFormatter,
  ProjectCountFormatter,
  CategoryCountFormatter,
  ServiceCountFormatter,
  WrappedTextFormatter,
  CapitalizedTextFormatter,

  DateTypeProvider,
  CurrencyTypeProvider,
  ColorCurrencyTypeProvider,
  PercentageTypeProvider,
  MarginTypeProvider,
  ProjectCountTypeProvider,
  CategoryCountTypeProvider,
  ServiceCountTypeProvider,
  WrappedTextTypeProvider,
  CapitalizedTextTypeProvider
}



// WEBPACK FOOTER //
// ./src/components/UI/FormatProviders.jsx